import { useState } from 'react';
import LoadingContainer from 'src/componentes/loading-container';
import Pagination from 'src/componentes/list/pagination';
import { useIntl } from 'react-intl';

const SecaoDefaultVerticalList = ({
  items = [],
  isLoading = false,
  icon: Icon,
  title,
  renderItem,
  pageSizeDefault = 5,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(pageSizeDefault);
  const intl = useIntl();

  const count = items?.length || 0;

  const currentData = items.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="border rounded-lg p-4 mb-4 shadow">
      <LoadingContainer isLoading={isLoading}>
        <div className="d-flex text-primary">
          {Icon && (
            <Icon
              style={{ width: '20px', marginBottom: '12px' }}
              className="mr-2"
            />
          )}
          <div className="text-primary text-base font-weight-bold mb-2 text-xl">
            {title}
          </div>
        </div>
        {!isLoading && currentData.length === 0 && (
          <div className="d-flex mt-3" style={{ height: 50 }}>
            {intl.formatMessage({ id: 'nenhumRegistroEncontrado' })}
          </div>
        )}
        {!isLoading &&
          currentData.map((item, index) => (
            <div key={index} className="mt-2">
              {renderItem(item)}
              <hr />
            </div>
          ))}

        <div className="d-flex w-100 justify-content-end">
          <Pagination
            allowPaging={true}
            currentPage={currentPage}
            count={count}
            pageSize={pageSize}
            showPaginacaoSimples={false}
            changeCurrentPage={setCurrentPage}
            changePageSize={setPageSize}
            noLimitPageSize={true}
          />
        </div>
      </LoadingContainer>
    </div>
  );
};

export default SecaoDefaultVerticalList;
